import { render, staticRenderFns } from "./m-numOfOnChainTx.vue?vue&type=template&id=d624e634&scoped=true&"
import script from "./m-numOfOnChainTx.vue?vue&type=script&lang=ts&"
export * from "./m-numOfOnChainTx.vue?vue&type=script&lang=ts&"
import style0 from "./m-numOfOnChainTx.vue?vue&type=style&index=0&id=d624e634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d624e634",
  null
  
)

export default component.exports